import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import { Column, Row } from 'styles/general'
import { Button } from 'styles/algolia/button'
import { ArtworkInfo } from 'styles/algolia/artwork/info'
import { FacetsLayout as FacetsLayoutBase } from 'styles/algolia/facets'
import { Header, ActionsLinks } from 'styles/algolia/collection/header'
// import { Breadcrumbs } from 'styles/breadcrumbs'
import { PlainLink } from 'components/A'
import { BreadcrumbContainer } from 'components/Breadcrumb'

const MOBILE_WIDTH = '999'

export const FacetsLayout = styled(FacetsLayoutBase)`
  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    display: none;
    ${(props) => props.isVisible && `display: block;`}
  }
`
export const Breadcrumbs = styled(BreadcrumbContainer)`
  width: 90vw;
  max-width: 1060px;
  display: flex;
  justify-content: flex-start;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
  margin-left: 0;
  margin-top: 20px;
  padding: 0 56px;

  @media (max-width: 499px) {
    padding: 0 16px;
  }

  [data-type='breadcrumbUL'] {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    list-style: none;
    overflow-x: auto;
    overflow-y: scroll;
    max-width: 700px;
    scrollbar-width: none;
    li {
      padding: 0;
      text-align: center;
      white-space: nowrap;
      margin: 0;
      font-size: 13px;
      a {
        color: ${(props) => props.theme.colors.secondary};
        font-weight: normal;

        :hover {
          color: ${(props) => props.theme.colors.lightGray};
        }
        &:after {
          content: '/';
          color: #333333;
          margin: 0 8px;
        }
      }
    }
    li:last-child {
      a {
        &:after {
          content: '';
        }
      }
    }
  }
  [data-type='breadcrumbUL']::-webkit-scrollbar {
    display: none;
  }
  span {
    white-space: nowrap;
  }
`
export const Link = styled(PlainLink)``
export const Layout = styled(Column)`
  //max-width: 1280px;
  padding: 0;
  margin: 0 auto;
  [data-type='artwork-info'] {
    [data-type='main'] {
      max-width: 250px;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    padding: 0;
  }
  ${Header} {
    padding: 0 56px;
    justify-content: center;
    align-items: center;
    border-bottom: none;
    h1,
    p {
      text-align: center;
      width: 100%;
    }
    @media (max-width: 499px) {
      padding: 0 16px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      h1 {
        font-size: 26px;
        border-bottom: none;
      }
    }
    ${Row} {
      align-items: center;
      justify-content: space-betweeen;
      border-top: 1px solid ${(props) => props.theme.colors.borderLight};
      padding-top: 24px;
      @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
        flex-direction: column;
        ${ActionsLinks} {
          border-top: 1px solid ${(props) => props.theme.colors.borderLight};
          padding: 10px;
        }
        ${Button} {
          margin: 10px 0;
        }
      }
    }
    ${Button},
    button[data-type="filter"] {
      @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
        display: flex;
        min-width: 250px;
      }
    }
  }
  ${ArtworkInfo} {
    margin-top: 10px;
  }
  ${Breadcrumbs} {
    margin-bottom: 0;
    padding-bottom: 0;
    a {
      font-weight: bold;
    }
    span {
      font-weight: bold;
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  @media (max-width: ${MOBILE_WIDTH}px) {
    align-items: flex-start;
  }

  [data-type='description-container'] {
    width: 70%;
    @media (max-width: ${MOBILE_WIDTH}px) {
      width: 100%;
      [data-type='header-description'] {
        text-align: start;
        width: 90%;
      }
    }
  }
`
